import { render, staticRenderFns } from "./ProductMovementPopupTable.vue?vue&type=template&id=336d28c2&"
import script from "./ProductMovementPopupTable.vue?vue&type=script&lang=js&"
export * from "./ProductMovementPopupTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductMovementPopupTable.vue?vue&type=style&index=0&id=336d28c2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('336d28c2')) {
      api.createRecord('336d28c2', component.options)
    } else {
      api.reload('336d28c2', component.options)
    }
    module.hot.accept("./ProductMovementPopupTable.vue?vue&type=template&id=336d28c2&", function () {
      api.rerender('336d28c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/stock/stock-movement/components/ProductMovementPopupTable.vue"
export default component.exports